import { render } from "./ItemProfileSaleTimer.vue?vue&type=template&id=1617e1b6&scoped=true"
import script from "./ItemProfileSaleTimer.vue?vue&type=script&lang=ts"
export * from "./ItemProfileSaleTimer.vue?vue&type=script&lang=ts"

import "./ItemProfileSaleTimer.vue?vue&type=style&index=0&id=1617e1b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1617e1b6"

export default script